import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { JobportalAddExperienceButton } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-experience/jobportal-add-experience-button';
import type { AddExperienceSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-experience/jobportal-add-experience-dialog';
import { JobportalAddExperienceDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-experience/jobportal-add-experience-dialog';
import { JobportalExperienceCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-experience/jobportal-experience-card';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';
import { useFormContext } from 'react-hook-form';

export const CreateCurriculumStep3 = () => {
  const { t } = useTranslations();

  const form = useFormContext<CreateCurriculumSchema>();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const experiences = form.watch('experiences');

  const handleExperienceEdit = (experience: AddExperienceSchemaType) => {
    if (experience.id === undefined) return;

    const newExperiences = experiences?.map((e: any) => {
      if (e.id === experience.id) {
        return experience;
      }
      return e;
    });
    form.setValue('experiences', newExperiences as any);
  };

  const handleExperienceEditClick = (experience: AddExperienceSchemaType) => {
    openDialog({
      id: JobportalAddExperienceDialog.id,
      content: (
        <JobportalAddExperienceDialog onEdit={handleExperienceEdit} dataToEdit={experience} />
      ),
    });
  };

  const handleExperienceDelete = (experience: AddExperienceSchemaType) => {
    const newExperiences = experiences?.filter((e: any) => e.id !== experience.id);
    form.setValue('experiences', newExperiences || []);
  };

  const handleExperienceDeleteClick = (experience: AddExperienceSchemaType) => {
    handleExperienceDelete(experience);
  };
  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('text863')}>
        <p className="text-[#63626F]">{t('text1751')}</p>
        <div className={cn('flex flex-col gap-2', 'ea-jobportal-add-language__cards-wrapper')}>
          {experiences?.length === 0 && (
            <p className={cn('p-6 text-muted-foreground', 'text-sm')}>{t('text1018')}</p>
          )}
          {experiences?.map((experience: any, index: number) => (
            <JobportalExperienceCard
              key={index}
              experience={experience}
              onExperienceEditClick={() => handleExperienceEditClick(experience)}
              onExperienceDeleteClick={() => handleExperienceDeleteClick(experience)}
            />
          ))}
        </div>
        <JobportalAddExperienceButton />
      </CreateCurriculumSection>
    </div>
  );
};
